import Vue from 'vue'

import Cookies from 'js-cookie'
import 'normalize.css/normalize.css' // a modern alternative to CSS resets
import Element from 'element-ui'
import './styles/element-variables.scss'
import '@/styles/index.scss' // global css
import App from './App'
import store from './store'
import router from './router'
import i18n from './lang' // internationalization
import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log
import * as filters from './filters' // global filters
 // 测试冲突  
import '@logicflow/core/dist/style/index.css'
import '@logicflow/extension/lib/style/index.css'

import vcolorpicker from 'vcolorpicker'

import VueCodeMirror from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import axios from 'axios'
import { getDicts } from "@/api/system/dict/data";
import { getConfigKey } from "@/api/system/config";
import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree } from "@/utils/ruoyi";
import { download } from '@/utils/request'
// 字典数据组件
import DictData from '@/components/DictData'
// 字典标签组件
// 分页组件
import Pagination from "@/components/Pagination";
// 自定义表格工具组件
import RightToolbar from "@/components/RightToolbar"
// 富文本组件
// import Editor from "@/components/Editor"
// 文件上传组件
// import FileUpload from "@/components/FileUpload"
// // 图片上传组件
// import ImageUpload from "@/components/ImageUpload"
// // 图片预览组件
// import ImagePreview from "@/components/ImagePreview"
// 字典标签组件
import DictTag from '@/components/DictTag'
// 头部标签组件
import VueMeta from 'vue-meta'
// 字典数据组件
// import DictData from '@/components/DictData'
import directive from './directive' // directive
import plugins from './plugins' // plugins
// main.js中
import wlExplorer from "wl-explorer";
import "wl-explorer/lib/wl-explorer.css"
import { dispatchEventStroage }  from '@/utils/watchLocalStorage'
import { alphanumericFilter,numericFilter,alphanumericSpecialDirective } from '@/util/input'

import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import VueVirtualScroller from 'vue-virtual-scroller'

Vue.use(wlExplorer);
Vue.prototype.$axios = axios
// 全局方法挂载
Vue.prototype.getDicts = getDicts
Vue.prototype.getConfigKey = getConfigKey
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.download = download
Vue.prototype.handleTree = handleTree
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */

if (process.env.NODE_ENV === 'production') {
  const { mockXHR } = require('../mock')
  mockXHR()
}
Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})

Vue.use(vcolorpicker)

Vue.use(VueVirtualScroller)

Vue.use(VueCodeMirror)
Vue.use(plugins)
// 全局组件挂载
Vue.component('DictTag', DictTag)
Vue.component('Pagination', Pagination)
Vue.component('RightToolbar', RightToolbar)
// Vue.component('Editor', Editor)
// Vue.component('FileUpload', FileUpload)
// Vue.component('ImageUpload', ImageUpload)
// Vue.component('ImagePreview', ImagePreview)
// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
DictData.install()
Vue.use(directive)
Vue.config.productionTip = false
Vue.use(dispatchEventStroage)

Vue.directive('alphanumeric', alphanumericFilter)
Vue.directive('numeric', numericFilter)
Vue.directive('alphanumeric-special', alphanumericSpecialDirective)

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
